import { http, httpgst } from '../../main'
import { store } from '../../store'

const actions = {
  // GET
  getUsers ({commit, dispatch}, payload) {
    let url = 'api/user'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetUser', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getAreas ({commit, dispatch}, payload) {
    let url = 'api/areas'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetAreas', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getCashier ({commit, dispatch}, payload) {
    let url = 'api/cashier-by-company'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetCashier', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },

  // POST
  postCashier ({ commit, dispatch }, payload) {
    let url = 'api/cashier'
    let params = {
      'user_id': payload.event.item.user_id,
      'area_id': payload.event.item.area_id
    }
    let user = { 'user_id': payload.event.item.user_id }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    if (payload.event.item.area_id !== null) {
      httpgst.post(url, params, {})
        .then(
          response => {
            commit('cashierPost', {event: payload.event, response: response})
          },
          error => {
            commit('onError', {event: payload.event, error: error})
          }
        )
    } else {
      httpgst.post(url, user, {})
        .then(
          response => {
            commit('cashierPost', {event: payload.event, response: response})
          },
          error => {
            commit('onError', {event: payload.event, error: error})
          }
        )
    }
  },

  // DELETE
  deleteCashier ({ commit, dispatch }, payload) {
    let url = 'api/cashier/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {})
      .then(
        response => {
          commit('cashierDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

const mutations = {
  // GET
  // Get the list of users
  onGetUser (state, payload) {
    let users = payload.response.data.data
    payload.event.context.users = users
  },
  // Get the list of areas
  onGetAreas (state, payload) {
    let areas = payload.response.data.data
    payload.event.context.areas = areas
  },
  // Get the list of cashiers
  onGetCashier (state, payload) {
    payload.event.context.cashiers = payload.response.data.data
    payload.event.context.loadingItems = false
  },

  // POST
  // add a new cashier
  cashierPost (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.getCashier()
    payload.event.context.loading = false
  },

  // DELETE
  // Delete a cashier from the data table
  cashierDelete (state, payload) {
    let cashiers = payload.event.context.cashiers
    cashiers.splice(payload.event.index, 1)
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeDelete()
    payload.event.context.loading = false
  },

  // ERROR
  // Shows a error message
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cashier.js